<template>
    <div class="survey-results">
        <loading-indicator v-if="$loading('survey-results')" />
        <div v-else>
            <div v-for="(surveyElement, index) in survey.survey_elements" :key="surveyElement.id_survey_element" class="survey-element">
                <div class="element-header">
                    <div class="element-title">{{ index + 1 }}. Element - {{ __(`survey_element_types/${surveyElement.type}`) }}</div>
                </div>
                <div class="element-body">
                    <div v-html="surveyElement.text" />
                    <template v-if="surveyElement.type === 0">
                        <div class="text-list">
                            <div class="text-list-element" v-for="answer in getAnswers(surveyElement.id_survey_element)" :key="answer.id_survey_element_answer">
                                {{ answer.value }}
                            </div>
                        </div>
                    </template>
                    <div v-if="[1,2].includes(surveyElement.type)">
                        <toggle v-if="surveyElement.data.hasCustomAnswer" class="my-2" :options="chartToggleOptions" v-model="chartToggles[index]" />
                        <div class="chart-container" v-if="chartToggles[index] === 'chart'">
                            <high-charts class="chart" v-bind="getChartData(surveyElement)" />
                        </div>
                        <div v-else class="text-list">
                            <div class="text-list-element" v-for="answer in getCustomAnswers(surveyElement)" :key="answer.id_survey_element_answer">
                                {{ answer.value }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .survey-results {
        .text-list {
            max-height: 300px;
            overflow-y: auto;
            background-color: white;
            padding: 0 5px 0 5px;
            border: 1px solid $gray-400;

            .text-list-element {
                padding-top: 10px;
                padding-bottom: 10px;

                &:not(:last-child) {
                    border-bottom: 1px solid $gray-400;
                }
            }
        }

        .chart-container {
            border: 1px solid $gray-400;
        }
    }
</style>

<script>
    import Survey from "../models/surveyModel";
    import SurveyElementAnswer from "../models/surveyElementAnswerModel";
    import HighCharts from "../apps/backend/components/HighCharts";

    export default {
        components: {
            HighCharts,
        },

        props: {
            survey: {type: Survey, required: true},
        },

        data() {
            return {
                chartToggles: [],
                chartToggleOptions: [
                    {key: 'chart', label: 'Diagramm'},
                    {key: 'list', label: 'Sonstige Antworten'},
                ],
            };
        },

        methods: {
            getAnswers(id_survey_element) {
                return SurveyElementAnswer.query().where("id_survey_element", id_survey_element).get();
            },

            getChartData(surveyElement) {
                let answers = this.getAnswers(surveyElement.id_survey_element);
                let categories = [];
                let categoryIds = [];
                let result = [];
                let chart_type = null;


                switch (surveyElement.type) {
                    case 1:
                        surveyElement.options.forEach(option => {
                            categories.push(option.value);
                            categoryIds.push(option.id_survey_select_option);
                            result.push(0);
                        });
                        if (surveyElement.data.hasCustomAnswer) {
                            categories.push('Sonstiges');
                            result.push(0);
                        }
                        answers.forEach(answer => {
                            if (surveyElement.data.multiSelection) {
                                JSON.parse(answer.value).forEach(value => {
                                    if (isNaN(value)) {
                                        result[result.length - 1]++;
                                    } else {
                                        let index = categoryIds.findIndex(e => e == value);
                                        if (!isNaN(index)) {
                                            result[index]++;
                                        }
                                    }
                                });
                            } else {
                                if (isNaN(answer.value)) {
                                    result[result.length - 1]++;
                                } else {
                                    let index = categoryIds.findIndex(e => e == answer.value);
                                    // findIndex() returns -1 if no index was found
                                    if (-1 !== index) {
                                        result[index]++;
                                    }
                                }
                            }
                        });

                        chart_type = 'pie';
                        break;
                    case 2:
                        for (let i = 1; i <= surveyElement.data.count; i++) {
                            categories.push(i);
                            result.push(0);
                        }
                        answers.forEach(answer => {
                            result[answer.value-1]++;
                        });
                        chart_type = 'bar';
                        break;
                }

                return {
                    data: result,
                    categories,
                    chart_type,
                    height: 300,
                    allow_decimals: false,
                };
            },

            getCustomAnswers(surveyElement) {
                let answers = this.getAnswers(surveyElement.id_survey_element);
                let result = [];
                answers.forEach(answer => {
                    if (surveyElement.data.multiSelection) {
                        let customValue = JSON.parse(answer.value).find(value => isNaN(value));
                        if (customValue) {
                            result.push({
                                value: customValue,
                                id_user: answer.id_user,
                            });
                        }
                    } else {
                        if (isNaN(answer.value)) {
                            result.push(answer);
                        }
                    }
                });
                return result;
            },
        },

        async created() {
            this.$loading('survey-results', true);
            this.survey.survey_elements.forEach(() => {
                this.chartToggles.push('chart');
            });
            this.$loading('survey-results', false);
        },
    };
</script>